import { render, staticRenderFns } from "./liability-summary.vue?vue&type=template&id=82b08cbc&scoped=true"
import script from "./liability-summary.vue?vue&type=script&lang=ts"
export * from "./liability-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b08cbc",
  null
  
)

export default component.exports